import React, { useContext, useEffect, useState } from "react";
import ContentLayout from "../../component/ContentLayout";
import AgGridTable from "../../component/AgGridTable";
import axios from "../../util/axios";
import CustomTextField from "../../component/TextField";
import { BsSend } from "react-icons/bs";
import CustomButton from "../../component/Button";
import { Context } from "../../component/Context/ErrorContext";
import * as Yup from "yup";
import { useFormik } from "formik";
import { Button } from "@mui/material";
import { styled } from "@mui/material/styles";
import * as XLSX from "xlsx";
import PhoneInput from "../../component/PhoneInput";
import { isOnlyCountryCode } from "../../util/util";

// const color: any = {
//   active: "border-green text-green",
//   pending: "border-pending text-pending",
//   invited: "border-invited text-invited",
//   activeBg: "bg-green text-green",
//   pendingBg: "bg-pending text-pending",
//   invitedBg: "bg-invited text-invited",
// };

const VisuallyHiddenInput = styled("input")({
  clip: "rect(0 0 0 0)",
  clipPath: "inset(50%)",
  height: 1,
  overflow: "hidden",
  position: "absolute",
  bottom: 0,
  left: 0,
  whiteSpace: "nowrap",
  width: 1,
});

const InviteUploadFile = () => {
  const { setError } = useContext(Context);
  const [loading, setLoading] = useState(false);
  const [colDefs, setCol] = useState<any>([]);
  const [rowData, setRowData] = useState<any[]>([]);

  const [country, setCountry] = useState<any>({});

  useEffect(() => {
    setCol([
      {
        field: "Name",
        headerName: "NAME",
        cellStyle: {
          display: "flex",
          alignItems: "center",
        },
      },
      {
        field: "Phone Number",
        headerName: "MOBILE NUMBER",
        cellStyle: {
          display: "flex",
          alignItems: "center",
        },
      },
      {
        field: "Email",
        headerName: "EMAIL",
        cellStyle: {
          display: "flex",
          alignItems: "center",
        },
      },
    ]);
  }, []);

  const validationSchema = Yup.object().shape({
    name: Yup.string().required("Name is required"),
    email: Yup.string().required("Email is required"),
    phone: Yup.string().required("phone is required"),
  });

  const formik = useFormik({
    initialValues: {
      name: "",
      email: "",
      phone: "",
    },
    validationSchema: validationSchema,
    onSubmit: (values, { setFieldError }) => {
      try {
        if (values.phone === "" || isOnlyCountryCode(values.phone, country)) {
          setFieldError("phone", "Required");
        } else {
          axios({
            URL: "/omw/subAdmin/createUser",
            method: "POST",
            data: values,
          })
            .then(() => {
              resetForm();
            })
            .catch((err) => setError(err.response?.data?.message));
        }
      } catch (error) {}
    },
  });

  const {
    handleSubmit,
    values,
    handleChange,
    setFieldValue,
    resetForm,
    errors,
  } = formik;

  console.log(errors);

  const handleFileChange = async (e: any) => {
    const file = e.target.files?.[0];
    if (!file) return;

    setLoading(true);
    try {
      const data = await file.arrayBuffer();
      const workbook = XLSX.read(data);
      const worksheet = workbook.Sheets[workbook.SheetNames[0]];
      const jsonData = XLSX.utils.sheet_to_json(worksheet);
      console.log(jsonData);
      setRowData(jsonData); // Show in ag-grid

      const formData = new FormData();
      formData.append("file", file);
      axios({
        URL: "/omw/subadmin-upload",
        method: "POST",
        data: formData,
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
        .then(() => {
          setLoading(false);
        })
        .catch((err) => setError(err.response?.data?.message));
    } catch (error) {
      setError("Invalid file format or error reading file.");
    } finally {
      setLoading(false);
    }

    // console.log("fileInput : ",fileInput);
    // if (fileInput && fileInput[0]) {
    //   setLoading(true);
    //   const formData = new FormData();
    //   formData.append("file", fileInput[0]);
    //   axios({
    //     URL: "/omw/subadmin-upload",
    //     method: "POST",
    //     data: formData,
    //     headers: {
    //       "Content-Type": "multipart/form-data",
    //     },
    //   })
    //     .then(() => {
    //       setLoading(false);
    //     })
    //     .catch((err) => setError(err.response?.data?.message));
    // }
  };

  const handleDownloadSamplefile = async (url: string, filename: string) => {
    try {
      if (!url) {
        setError("Download URL not found");
        return;
      }

      const response = await fetch(url, {
        headers: {
          Accept:
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/pdf, video/mp4",
        },
      });

      if (!response.ok) {
        throw new Error("Download failed");
      }

      const contentType = response.headers.get("content-type");
      const blob = await response.blob();

      // Set the correct MIME type for Excel files
      const blobOptions = {
        type:
          contentType ||
          (filename.endsWith(".xlsx")
            ? "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            : blob.type),
      };
      const downloadUrl = window.URL.createObjectURL(
        new Blob([blob], blobOptions),
      );

      const link = document.createElement("a");
      link.href = downloadUrl;
      link.download = filename;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      // Clean up the URL object
      window.URL.revokeObjectURL(downloadUrl);
      console.log("Download started successfully");
    } catch (error) {
      console.error("Error downloading file:", error);
      setError("Failed to download file. Please try again.");
    }
  };

  return (
    <ContentLayout
      className={"items-start rounded-3xl m-2 gap-6 overflow-y-scroll"}
    >
      <div className={"flex justify-between items-center w-full"}>
        <p className={"text-3xl font-bold text-primaryText"}>
          Upload File To Preview File Data
        </p>
        <div className={"flex gap-4 justify-center items-center"}>
          <CustomButton
            className={"!border !border-sidebarSelectText"}
            title={"Download Sample File"}
            onClick={() =>
              handleDownloadSamplefile("/sample.xlsx", "sample.xlsx")
            }
            variant={"outlined"}
            bgColor={"bg-transparent"}
            textColor={"text-sidebarSelectText"}
          />
          <Button
            component="label"
            role={undefined}
            variant="contained"
            tabIndex={-1}
            className={`flex items-center justify-center bg-sidebarSelectText text-white px-8 py-2 rounded-md sm:w-auto w-full capitalize`}
            disabled={loading}
          >
            {loading ? "Uploding..." : "Upload File"}
            <VisuallyHiddenInput
              type="file"
              onChange={(e) => handleFileChange(e)}
            />
          </Button>
        </div>
      </div>
      <div className="ag-theme-quartz w-full min-h-[270px] h-1/2">
        <AgGridTable
          rowData={rowData}
          colDefs={colDefs}
          loading={loading}
          height={"100%"}
        />
      </div>
      <div
        className={
          "w-full flex flex-col justify-center items-center gap-4 bg-primary rounded-lg p-4"
        }
      >
        <div
          className={
            "flex flex-col justify-center items-center w-full p-4 gap-4"
          }
        >
          <BsSend className={"text-sidebarSelectText text-6xl"} />
          <div className={"text-3xl font-bold text-primaryText"}>
            Quick Invite
          </div>
          <div
            className={
              "text-sm font-semibold text-primaryText w-3/5 opacity-75"
            }
          >
            Quickly invite new Employees to join your team. Just enter their
            name, email, mobile number, and we’ll send a personalized invite
            straight to their inbox—quick and simple.
          </div>
        </div>
        <form
          onSubmit={handleSubmit}
          className={"mt-5 w-full max-w-full gap-4 grid grid-cols-4 p-4"}
          autoComplete={"off"}
        >
          <CustomTextField
            label={"Employee Name"}
            placeholder={"Enter Employee Name"}
            type={"text"}
            name={"name"}
            value={values?.name}
            onChange={handleChange}
            required
          />
          <CustomTextField
            label={"Email Address"}
            placeholder={"Enter Email Address"}
            type={"text"}
            name={"email"}
            value={values?.email}
            onChange={handleChange}
            required
          />
          <PhoneInput
            label={"Phone Number"}
            onChange={(v) => setFieldValue("phone", v)}
            value={values?.phone}
            countryChange={setCountry}
            required
            errorMsg={errors?.phone || ""}
          />
          <CustomButton
            type={"submit"}
            title={"Invite Employee"}
            className={" p-4 font-semibold h-14 self-end"}
          />
        </form>
      </div>
    </ContentLayout>
  );
};

export default InviteUploadFile;
